import IntegrationStatuses from 'ContentUtils/constants/IntegrationStatuses';
export const getIntegrationStatusKey = status => {
  switch (status) {
    case IntegrationStatuses.INTEGRATED_AND_DISABLED:
    case IntegrationStatuses.USER_DISABLED:
      {
        return 'disabledMessage';
      }
    case IntegrationStatuses.REAUTHORIZE:
    case IntegrationStatuses.AUTH_ERROR:
    case IntegrationStatuses.DEPRECATED_AUTH_TOKEN:
      {
        return 'unauthorizedMessage';
      }
    case IntegrationStatuses.NOT_INTEGRATED:
    case IntegrationStatuses.WARNING:
    case IntegrationStatuses.ERROR:
    case IntegrationStatuses.UNKNOWN_ERROR:
    case IntegrationStatuses.THIRD_PARTY_AVAILABILITY_ERROR:
      {
        return 'notIntegratedMessage';
      }
    case IntegrationStatuses.DELAY:
      {
        return 'delayMessage';
      }
    default:
      return null;
  }
};